/**
 * Import blocks with frontend code.
 */
import "./blocks/course-content-slider/frontend";
import "./blocks/tabs/frontend";
